// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1330":"css/app.6775","5364":"css/admin-app.6775"}[chunkId] + ".css";
};